
import React from 'react';
import { RootErrorBoundary } from './components/error/RootErrorBoundary';
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ScrollToTop } from './components/navigation/ScrollToTop';
import { AppProviders } from './contexts/AppProviders';
import MaintenancePage from './components/MaintenancePage';
import './index.css';

// MODE MAINTENANCE ACTIVÉ
// Pour désactiver: remettre le code original avec App, i18n, etc.
const MAINTENANCE_MODE = true;

const root = createRoot(document.getElementById("root")!);

if (MAINTENANCE_MODE) {
  root.render(
    <React.StrictMode>
      <MaintenancePage />
    </React.StrictMode>
  );
} else {
  // Code original commenté - à réactiver après maintenance
  // import App from './App.tsx';
  // import i18n from './i18n/config';
  // import { initWebVitals } from './utils/webVitals';
  // initWebVitals();
  // ... renderApp avec App, i18n, etc.
}
